import { useDispatch } from 'react-redux';
import { XCloseIcon } from '@rsos/base-assets/icons';
import { useInteragencyConversationById } from '../../../reduxDataStore/interagency/interagencyAPI';
import {
  setSelectedInteragencyChat,
  useSelectedInteragencyChat,
} from '../../../reduxDataStore/interagency/interagencySlice';
import InteragencyChatBox from '../../InteragencyChat';
import styles from './InteragencyPane.module.scss';

const InteragencyPane = () => {
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(setSelectedInteragencyChat(null));
  };

  const selectedConversation = useSelectedInteragencyChat();
  const conversation = useInteragencyConversationById(selectedConversation);

  return (
    <div className={styles.dock}>
      <div className={styles.pane}>
        <div className={styles.header}>
          <div className={styles.title}>{conversation?.conversation_name}</div>
          <button
            type="button"
            className={styles.closeButton}
            onClick={handleClose}
          >
            <XCloseIcon /> Close
          </button>
        </div>
        <InteragencyChatBox />
      </div>
    </div>
  );
};

export default InteragencyPane;
